import { baseUrl, authUrl } from '@/api/types';

export function subscriptionIndexUrl() {
  return `${baseUrl}/subscription`;
}

export function checkoutIndexUrl() {
  return `${baseUrl}/checkout`;
}

export function cancelDowngradeUrl() {
  return `${baseUrl}/subscription/cancel-downgrade`;
}

export function paymentShowUrl(paymentId) {
  if (paymentId) {
    return `${authUrl}/payments/${paymentId}/show`;
  }

  return `${authUrl}/payments/show`;
}

export function stripePaymentShowUrl() {
  return `${authUrl}/stripe-payments/show`;
}

export function paymentPdfUrl(paymentId) {
  return `${authUrl}/payments/${paymentId}/pdf`;
}

export function paymentDeleteUrl(paymentId) {
  return `${authUrl}/payments/${paymentId}`;
}

export function discountApplyUrl() {
  return `${baseUrl}/discount`;
}

export function discountResolveUrl() {
  return `${baseUrl}/discount/resolve`;
}

export function recurringSubscriptionCancelUrl() {
  return `${baseUrl}/stripe-subscription/cancel`;
}

export function updateStripePaymentMethodUrl() {
  return `${baseUrl}/stripe-payment-methods/update`;
}

export function removeStripePaymentMethodUrl(paymentMethodId) {
  return `${baseUrl}/stripe-payment-methods/${paymentMethodId}`;
}

export function updateStripeDefaultMethodUrl() {
  return `${baseUrl}/stripe-payment-methods/update-active-method`;
}

export function updateStripePaymentCompanyUrl() {
  return `${baseUrl}/stripe-payment-company/update`;
}
